import VehicleInvoicesHtml from './templates/vehicle-invoices.html';

export function VehicleInvoicesDirective () {
  return {
    controller: 'VehicleInvoicesCtrl',
    restrict: 'E',
    templateUrl: VehicleInvoicesHtml,
    scope: {
      vehicle: '=',
      invoices: '=',
      customer: '='
    }
  }
}